<template>
  <div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="card pb-5 my-5" style="width:100%">
          <div class="card-body">
            <div class="text-center mb-4">
              <img src="../assets/img/hokodo_logo_color.svg" alt="Hokodo" width="200" height="38.5">
            </div>
            <div class="text-center mb-4">
              <div class="text-center" v-if="loading">
                <h3><icon name="settings" class="feather-spin feather-large-muted"></icon></h3>
                <h3 class="my-4">Confirming your email</h3>
                <p class="pb-4">Please wait while we confirm your email.</p>
              </div>
              <div class="mt-4" v-else-if="!error">
                <icon name="check-circle" class="feather-large"></icon>
                <h3 class="my-4">Your email has been confirmed</h3>
                <p>You will be redirected shortly.</p>
              </div>
              <div class="mt-4" v-else>
                <icon name="alert-circle" class="feather-large-muted"></icon>
                <h3 class="my-4">Something went wrong</h3>
                <p>We could not confirm your email.<br>Please contact us if you believe this is an error.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hokodo-footer></hokodo-footer>
  </div>
</template>

<script>
import HokodoFooter from './partials/HokodoFooter'

export default {
  data () {
    return {
      loading: true,
      error: null
    }
  },
  props: ['nonce'],
  components: {
    HokodoFooter
  },
  mounted () {
    this.confirmEmail()
  },
  methods: {
    confirmEmail: function () {
      this.$store.dispatch('auth/confirmEmail', {key: this.nonce}).then(() => {
        // Successfully logged in - redirect the user to Home component
        this.loading = false
        var vm = this
        setTimeout(function () { vm.$router.push('/home/account') }, 3000)
      }, (error) => {
        // Login failed
        this.error = true
        this.loading = false
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmEmail.vue